// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CalmLiveLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 112 49"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M37.759.5h-26.12C5.597.5.7 5.398.7 11.44v26.12c0 6.042 4.898 10.94 10.94 10.94h26.12c6.042 0 10.94-4.898 10.94-10.94V11.44C48.699 5.398 43.801.5 37.759.5Z"
			fill="url(#CalmLiveLogo_tsx__a)"
		/>
		<path
			d="M37.759.5h-26.12C5.597.5.7 5.398.7 11.44v26.12c0 6.042 4.898 10.94 10.94 10.94h26.12c6.042 0 10.94-4.898 10.94-10.94V11.44C48.699 5.398 43.801.5 37.759.5Z"
			fill="url(#CalmLiveLogo_tsx__b)"
		/>
		<path
			d="M45.746 30.456a.292.292 0 0 0-.286-.148.291.291 0 0 0-.108.035c-.305.169-1.32.508-1.64.623-1.204.197-2.677.152-3.403-1.605-.219-.53-.435-1.006-.81-1.505-.422-.565-1.806-1.241-3.098-.025-.31.292-.579.624-.8.988a7.622 7.622 0 0 0-.245.418 2.63 2.63 0 0 0-.015-.056c-.114-.393-.48-1.848-2-2.084-.208-.017-1.054-.112-2.224 1.17a11.01 11.01 0 0 0-1.066 1.398c-.055-.26-.123-.497-.188-.601-.994-1.529-2.499-.308-3.147.147-1.453 1.022-2.127 2.394-3.01-.724a13.04 13.04 0 0 1-.276-1.34c.883-1.5 2.681-6.06 1.646-9.119-.067-.193-.426-1.18-1.289-1.117-.124.012-1.107-.09-1.646 2.656-.503 2.656-.392 6.079-.27 7.213.014.118.039.35.085.654-.852 1.456-1.969 3.11-2.65 3.188-.885.1-.639-.714-1.177-2.525-.094-.235-.39-1.354-1.733-1.299-.658.028-1.35.198-2.3 1.236-1.54 1.684-5.053 4.219-7.566 2.626-.273-.212-1.63-1.321-1.129-4.646a10.7 10.7 0 0 1 .806-2.653c.37-.825.832-1.605 1.38-2.323 2.582-3.17 4.818-3.54 5.26-3.521 1.13 0 1.425 1.464 1.424 1.45a.467.467 0 0 0 .917.095.47.47 0 0 0 .014-.185 2.567 2.567 0 0 0-.191-.92c-.177-.577-.688-1.113-.984-1.31-1.419-.987-4.621-.192-7.722 3.387a12.55 12.55 0 0 0-1.62 2.64 12.186 12.186 0 0 0-.941 3.071c-.84 5.895 2.749 6.833 3.36 6.948 3.146.367 5.462-1.345 6.558-2.395.394 1.968 2.362 1.991 3.225 1.103.22-.234.4-.503.534-.795.511 1.86 2.15 1.226 2.343 1.143.914-.341 1.87-1.613 2.545-2.68.429 1.462 1.258 3.03 2.85 2.862.958-.023 3.363-2.579 3.586-2.245.222.275.282.782.266 1.538-.016.756.586.794.858.718.42-.116.684-.944 1.124-1.663.27-.453.586-.875.944-1.26.173-.185.954-.993 1.506-.719.551.274.607.838.645 1.15.038.312.043.644.056 1.006-.016 1.253.572 1.43.738 1.476 1.361.367 1.445-2.191 2.446-3.14.094-.098.966-.998 1.464.47.72 2.655 2.934 3.647 5.914 2.171.553-.274.662-.381.964-.605a.291.291 0 0 0 .076-.372Zm-29.158-.539c-.594 1.223-1.904 1.15-1.886-.184.02-1.364 1.72-2.225 2.177-1.274.037.081.066.166.088.252-.08.251-.111.656-.379 1.206Zm7.321-11.502c.25.465.79 3.371-.682 6.549-.004-.101-.008-.202-.01-.304-.013-5.163.644-6.334.692-6.245Z"
			fill="#fff"
		/>
		<path
			d="M56.246 20.558h1.904v9.005h4.547v1.692h-6.45V20.558ZM65.474 20.558h1.903v10.697h-1.903V20.558ZM69.919 20.558h2.13l2.946 8.234h.06l2.977-8.234h2.055l-4.291 10.697h-1.647l-4.23-10.697ZM82.474 20.558h7.086v1.662h-5.182v2.72h4.91v1.601h-4.91v3.022h5.454v1.692h-7.358V20.558Z"
			fill="#1B3E8E"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M103.223 19.296a6.524 6.524 0 1 1 0 13.048 6.524 6.524 0 0 1 0-13.048Zm0-1.553a8.078 8.078 0 1 1 0 16.156 8.078 8.078 0 0 1 0-16.156Zm0 12.738a4.66 4.66 0 1 0 0-9.322 4.66 4.66 0 0 0 0 9.322Z"
			fill="url(#CalmLiveLogo_tsx__c)"
		/>
		<defs>
			<linearGradient
				id="CalmLiveLogo_tsx__a"
				x1={24.699}
				y1={48.5}
				x2={24.699}
				y2={0.5}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#3478DD" />
				<stop offset={1} stopColor="#3BBEEC" />
			</linearGradient>
			<linearGradient
				id="CalmLiveLogo_tsx__b"
				x1={0.618}
				y1={69.844}
				x2={27.147}
				y2={19.891}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#793BEB" />
				<stop offset={1} stopColor="#793BEB" stopOpacity={0} />
			</linearGradient>
			<linearGradient
				id="CalmLiveLogo_tsx__c"
				x1={102.715}
				y1={33.917}
				x2={102.221}
				y2={17.768}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#3ABBEB" />
				<stop offset={1} stopColor="#BCE808" />
			</linearGradient>
		</defs>
	</svg>
);
export default CalmLiveLogo;
